import { EditorHandlers } from '../types';

/**
 * Handlers for editor controls
 */
export const createEditorHandlers = (
  setRotation: (value: React.SetStateAction<number>) => void,
  setScale: (value: React.SetStateAction<number>) => void,
  setFlipX: (value: React.SetStateAction<boolean>) => void,
  setOffsetX: (value: React.SetStateAction<number>) => void,
  setOffsetY: (value: React.SetStateAction<number>) => void,
  // Masked uploads default to a cover-fit scale rather than 1; Reset returns there
  getDefaultScale: () => number = () => 1
): EditorHandlers => {
  const handleRotateLeft = () => setRotation((r) => r - 10);
  const handleRotateRight = () => setRotation((r) => r + 10);
  const handleFlipX = () => setFlipX((f) => !f);
  const handleZoomOut = () => setScale((s) => Math.max(0.1, s - 0.1));
  const handleZoomIn = () => setScale((s) => Math.min(3, s + 0.1));
  const handleMoveLeft = () => setOffsetX((x) => x - 20);
  const handleMoveRight = () => setOffsetX((x) => x + 20);
  const handleMoveUp = () => setOffsetY((y) => y - 20);
  const handleMoveDown = () => setOffsetY((y) => y + 20);
  const handleResetAll = () => {
    setRotation(0);
    setScale(getDefaultScale());
    setFlipX(false);
    setOffsetX(0);
    setOffsetY(0);
  };

  return {
    handleRotateLeft,
    handleRotateRight,
    handleFlipX,
    handleZoomOut,
    handleZoomIn,
    handleMoveLeft,
    handleMoveRight,
    handleMoveUp,
    handleMoveDown,
    handleResetAll
  };
};
